import moment from "moment";

const Color = {
  primary: "#B9F78A",
  transparent: "transparent",
  green: "#B9F78A", // 使用主题色
  red: "#D94F4F",
};
const Theme = {
  light: {
    name: "Light",
    bgColor: "#fff",
    lineColor: "rgba(0, 0, 0, 0.03)",
    textColor: "rgba(0, 0, 0, 0.4)",
    lineColor_area: "rgba(51, 51, 51, 1)",
    lineColor_area_03: "rgba(51, 51, 51, 0.3)",
  },
  dark: {
    name: "Dark",
    bgColor: "#181a20",
    lineColor: "rgba(255, 255, 255, 0.03)",
    textColor: "rgba(255, 255, 255, 0.4)",
    lineColor_area: "rgba(234, 236, 239, 1)",
    lineColor_area_03: "rgba(234, 236, 239, 0.3)",
  },
};

export const getTimezone = () => {
  const utcOffset = moment().utcOffset();
  const utcHour = Math.round(utcOffset / 60);
  const obj = {
    "-10": "Pacific/Honolulu",
    "-8": "America/Juneau",
    "-7": "America/Los_Angeles",
    "-6": "America/El_Salvador",
    "-5": "America/Chicago",
    "-4": "America/New_York",
    "-3": "America/Sao_Paulo",
    0: "Etc/UTC",
    1: "Africa/Lagos",
    2: "Africa/Cairo",
    3: "Asia/Jerusalem",
    4: "Asia/Dubai",
    "4:30": "Asia/Tehran",
    5: "Asia/Ashkhabad",
    "5:30": "Asia/Kolkata",
    "5:45": "Asia/Kathmandu",
    6: "Asia/Almaty",
    7: "Asia/Bangkok",
    8: "Asia/Hong_Kong",
    9: "Asia/Tokyo",
    "9:30": "Australia/Adelaide",
    10: "Australia/Brisbane",
    11: "Pacific/Norfolk",
    12: "Pacific/Auckland",
    13: "Pacific/Fakaofo",
  };

  const timezone = obj[utcHour + ""] || "Etc/UTC";
  // console.log("timezone =", timezone);
  return timezone;
};

interface Props {
  theme: string; //"dark" | "light"
  klineColorScheme?: "green_up" | "red_up"; // K线颜色方案：绿涨红跌 | 红涨绿跌
}

const config = (arg: Props) => {
  const { theme, klineColorScheme = "green_up" } = arg;
  const themeObj = Theme[theme];
  
  // 根据颜色方案设置涨跌颜色
  // green_up: 绿涨红跌 (upColor=green, downColor=red)
  // red_up: 红涨绿跌 (upColor=red, downColor=green)
  const upColor = klineColorScheme === "green_up" ? Color.green : Color.red;
  const downColor = klineColorScheme === "green_up" ? Color.red : Color.green;

  return {
    library_path: "/charting_library22/",
    custom_css_url: "/charting_library22/chart-sytle-ssr.css",
    timezone: getTimezone(),
    autosize: true,
    theme: themeObj.name,
    toolbar_bg: themeObj.bgColor, // 外围背景颜色
    volumePaneSize: "small", //指标区域大小（large, medium, small, tiny）
    loading_screen: {
      //定制加载进度条
      backgroundColor: themeObj.bgColor,
      foregroundColor: Color.primary,
    },
    overrides: {
      "paneProperties.legendProperties.showLegend": false, //关闭图例显示
      "mainSeriesProperties.candleStyle.upColor": upColor, // k线图的柱形颜色 涨
      "mainSeriesProperties.candleStyle.downColor": downColor, // k线图的柱形颜色 跌
      "mainSeriesProperties.candleStyle.drawWick": true,
      "mainSeriesProperties.candleStyle.drawBorder": false,
      "mainSeriesProperties.candleStyle.borderUpColor": upColor, // hover的字体颜色变化
      "mainSeriesProperties.candleStyle.borderDownColor": downColor,
      "mainSeriesProperties.candleStyle.wickUpColor": upColor,
      "mainSeriesProperties.candleStyle.wickDownColor": downColor,
      "mainSeriesProperties.candleStyle.barColorsOnPrevClose": false,
      "scalesProperties.showStudyLastValue": false,
      //
      "paneProperties.background": themeObj.bgColor, //中间背景颜色
      "scalesProperties.lineColor": themeObj.lineColor, //网格外的边框颜色
      "scalesProperties.textColor": themeObj.textColor, //字体颜色
      // 先启用 TradingView 原生十字线效果，方便在移动端验证「点按/长按 K 线查看价格」。
      // 如后续要做设计稿那种绿色价格气泡，再基于 crossHairMoved 事件叠加自定义浮层即可。
      "paneProperties.crossHairProperties.color": "rgba(255, 255, 255, 0.56)",
      "paneProperties.crossHairProperties.style": 2,
      "paneProperties.crossHairProperties.width": 1,
      "paneProperties.backgroundGradientStartColor": themeObj.bgColor, //背景渐变开始
      "paneProperties.backgroundGradientEndColor": themeObj.bgColor, //背景渐变结束
      "paneProperties.vertGridProperties.color": themeObj.lineColor, // 网格竖线
      "paneProperties.horzGridProperties.color": themeObj.lineColor, // 网格竖线
      //面积图
      "mainSeriesProperties.areaStyle.linewidth": 1,
      "mainSeriesProperties.areaStyle.linecolor": themeObj.lineColor_area,
      "mainSeriesProperties.areaStyle.color1": themeObj.lineColor_area_03,
      "mainSeriesProperties.areaStyle.color2": Color.transparent,
    },
    studies_overrides: {},
    time_frames: [],
    disabled_features: [
      // "widget_logo", //tradingview logo
      "header_widget", //隐藏头部的组件dom
      // "timeframes_toolbar", //底部时间栏
      "volume_force_overlay", //在主数据列的同一窗格上放置成交量指示器  防止他们重叠
      // 关闭 TradingView 默认自动创建的 Volume 副图；仅配这一项还不够，
      // 若本地 saved_data 里保存过 Volume study，还会在恢复布局时再次出现。
      "create_volume_indicator_by_default", //关闭默认成交量副图
      "use_localstorage_for_settings", //不加会出现黑线
      "display_market_status", //关闭开市状态
      "popup_hints", //提示信息
      
      // ========== 以下为简化配置新增的禁用功能 ==========
      // 如需恢复某个功能，将对应的行注释掉即可
      "control_bar", //禁用控制栏 (chart-controls-bar)
      "legend_widget", //禁用图例组件 (legend-1WIwNaDF noWrap-1WIwNaDF directionColumn-1WIwNaDF)
      "edit_buttons_in_legend", //禁用图例中的编辑按钮
      "context_menus", //禁用右键菜单
      "drawing_toolbar", //禁用绘图工具栏
      "left_toolbar", //禁用左侧工具栏
      "header_chart_type", //禁用头部图表类型选择
      "header_compare", //禁用头部比较功能
      "header_screenshot", //禁用头部截图功能
      "header_saveload", //禁用头部保存/加载功能
      "header_settings", //禁用头部设置
      "header_undo_redo", //禁用头部撤销/重做
      "header_symbol_search", //禁用头部符号搜索
      "header_resolutions", //禁用头部分辨率选择
      "header_indicators", //禁用头部指标
      // "chart_toolbar", //禁用图表工具栏 (如果TradingView支持此功能)
      // ========== 简化配置结束 ==========
    ],
    enabled_features: [
      "adaptive_logo", //小屏幕上隐藏 'charts byTradingView' 文本
      "dont_show_boolean_study_arguments", //是否隐藏指标参数
      "move_logo_to_main_pane", //logo在中间位置
      // "disable_resolution_rebuild", //显示的时间与得到的数据时间一致
      "hide_last_na_study_output", //隐藏最后一次指标输出,隐藏指标后面的 n/a
      "same_data_requery", //允许您使用相同的商品调用 setSymbol 来刷新数据
      "hide_left_toolbar_by_default", //第一次打开图表时隐藏左工具栏
    ],
  };
};

export default config;
